import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);

  return (
    <div data-testid="blog-page" className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-12 py-14">
      <div className="text-center mb-14">
        <span className="eyebrow">The Journal</span>
        <h1 className="font-display text-4xl sm:text-6xl mt-3">Stories from the Valley</h1>
      </div>
      <div className="grid md:grid-cols-2 gap-8">
        {posts.map((p, i) => (
          <motion.div key={p.slug} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}>
            <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="lux-card overflow-hidden block hover-lift group">
              <div className="aspect-[16/9] overflow-hidden">
                <img src={p.cover_image} alt={p.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6">
                <span className="eyebrow">{p.author}</span>
                <h2 className="font-display text-2xl mt-2 group-hover:text-[#D4AF37] transition">{p.title}</h2>
                <p className="text-[#8C7B6E] text-sm mt-2 line-clamp-2">{p.excerpt}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
